import React from 'react';
import { FormattedNumber } from 'react-intl';

import { StarFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';

import MyIcon from 'components/Icon';
import Truncate from 'components/Truncate';
import { URL_SELECT } from 'settings';

interface IProps {
  data: any;
}

const ProductCard: React.FC<IProps> = ({ data }) => {
  const borderColor = '#EEEEEE';
  const primary = '#0D2772';
  const primaryLight = '#223D80';
  const grey400 = '#818B9D';

  return (
    <a onClick={() => window.open(`${URL_SELECT}/product/details/${data.id}`)}>
      <div
        className='h-full cursor-pointer rounded-sm bg-white pb-2 text-center transition-colors duration-200 hover:bg-[#fafafa] hover:shadow-md'
        style={{ border: `1px solid ${borderColor}` }}
      >
        <div className='mx-auto my-4 block h-[150px] w-[150px] max-w-full overflow-hidden [&>img]:w-full [&>img]:rounded-sm'>
          <img src={data.image ? data.image : ''} alt='Product' />
        </div>
        <div
          className='px-2 pt-0 pb-2 text-sm leading-snug font-normal [&>div]:max-h-9 [&>div]:min-h-9'
          style={{ color: primary }}
        >
          <Truncate title={data.title} final={' '} count={34}>
            {data.title}
          </Truncate>
        </div>
        <div className='px-8 pt-0 pb-2 text-xs leading-snug font-normal' style={{ color: grey400 }}>
          <Truncate title={data.producer_name} final={' '} count={20}>
            {data.producer_name}
          </Truncate>
        </div>
        <div className='flex items-center justify-between p-4 [&>img]:w-6'>
          <Tooltip placement='top' title={data.infinity_funnel ? 'Funil Infinito Ativo' : 'Funil Infinito Inativo'}>
            <img src={data.infinity_funnel ? '/img/icon_funil_ativo.png' : '/img/icon_funil.png'} alt='Icon' />
          </Tooltip>
          <Tooltip
            placement='top'
            title={data.sales_recovery ? 'Recuperação de Vendas Ativa' : 'Recuperação de Vendas Inativa'}
          >
            <img
              src={data.sales_recovery ? '/img/icon_recuperacao_ativo.png' : '/img/icon_recuperacao.png'}
              alt='Icon'
            />
          </Tooltip>
          {(data.has_subscription || data.charge_type === 'A') && (
            <Tooltip title='Possui cobrança recorrente' placement='top'>
              <div>
                <MyIcon style={{ width: 24, display: 'flex', alignItems: 'center' }} name='icon-assinaturas' />
              </div>
            </Tooltip>
          )}
          {data.recruit === true && (
            <Tooltip title='Possui comissão de recrutamento' placement='top'>
              <img src='/img/icon_recruit.png' alt='Recruit' />
            </Tooltip>
          )}
          <Tooltip placement='top' title='RPC Produtor'>
            <div className='text-right text-sm' style={{ color: primaryLight }}>
              <span className='block text-xs' style={{ color: primary }}>
                RPC P
              </span>
              {data.rpc_producer !== 0 ? <FormattedNumber maximumFractionDigits={2} value={data.rpc_producer} /> : '-'}
            </div>
          </Tooltip>
          <Tooltip placement='top' title='RPC Afiliados'>
            <div className='text-right text-sm' style={{ color: primaryLight }}>
              <span className='block text-xs' style={{ color: primary }}>
                RPC A
              </span>
              {data.rpc_affiliate !== 0 ? (
                <FormattedNumber maximumFractionDigits={2} value={data.rpc_affiliate} />
              ) : (
                '-'
              )}
            </div>
          </Tooltip>
        </div>
        <div className='flex items-center justify-between px-4 py-2'>
          <div>
            <span className='block text-left text-xs font-medium' style={{ color: primary }}>
              Comissão:
            </span>
            <span className='block text-left text-[13px] font-normal' style={{ color: primary }}>
              {data.showcase_subscription_commission &&
                !data.showcase_subscription_commission.includes('R$ 0,00') &&
                `${data.showcase_subscription_commission} rec.`}
            </span>
            <span className='block text-left text-[13px] font-normal' style={{ color: primary }}>
              {data.showcase_commission &&
                !data.showcase_commission.includes('R$ 0,00') &&
                `${data.showcase_commission}`}
            </span>
          </div>
          <div className='flex items-center text-right text-sm' style={{ color: primary }}>
            {data.rating !== '0' ? data.rating : '-'}
            <span className='ml-1 text-[#FBCB41]'>
              <StarFilled />
            </span>
          </div>
        </div>
      </div>
    </a>
  );
};

export default ProductCard;
